(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuButton = document.querySelector('.menu-button');
  const closeButton = mobileMenu.querySelector('.close-button');
  const birthdayInput = document.querySelector('#contact-birth_date');
  const tagsInput = document.querySelector('#contact-tags');
  const newsletterMessage = document.querySelector('.newsletter-message');
  const closeNewsletterMessageButton = newsletterMessage.querySelector('[data-close]');
  const searchForm = document.querySelector('.search-form');
  const searchButton = searchForm.querySelector('.search-button');
  const searchInput = searchForm.querySelector('.search-input');
  const params = new URLSearchParams(window.location.search);

  if (params.get('customer_posted') === 'true' && window.location.hash === '#contact_form') {
    newsletterMessage.classList.remove('hidden');
    setTimeout(() => {
      newsletterMessage.classList.add('hidden');
    }, 5000);
  }

  closeNewsletterMessageButton.addEventListener('click', () => {
    newsletterMessage.classList.add('hidden');
  });

  menuButton.addEventListener('click', () => {
    mobileMenu.classList.remove('left-full');
    mobileMenu.classList.add('left-0');
  });

  closeButton.addEventListener('click', () => {
    mobileMenu.classList.remove('left-0');
    mobileMenu.classList.add('left-full');
  });

  birthdayInput.addEventListener('change', () => {
    const birthday = 'birthday:' + birthdayInput.value;
    tagsInput.value = birthday;
  });

  const collapsedClasses = ['w-0', 'px-0', 'opacity-0', 'mr-0'];
  const expandedClasses = ['w-56', 'px-4', 'opacity-100', 'mr-2'];

  const isSearchOpen = () => searchInput.classList.contains('opacity-100');

  const openSearch = () => {
    searchInput.classList.remove(...collapsedClasses);
    searchInput.classList.add(...expandedClasses);
    searchInput.removeAttribute('tabindex');
    searchInput.focus();
  };

  const closeSearch = () => {
    searchInput.classList.add(...collapsedClasses);
    searchInput.classList.remove(...expandedClasses);
    searchInput.setAttribute('tabindex', '-1');
    searchInput.blur();
  };

  searchButton.addEventListener('click', () => {
    if (!isSearchOpen()) {
      openSearch();
    } else if (searchInput.value.trim() !== '') {
      searchForm.submit();
    } else {
      closeSearch();
    }
  });

  document.addEventListener('click', (event) => {
    if (isSearchOpen() && !searchForm.contains(event.target)) closeSearch();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSearch();
  });

  } catch(e) { console.error(e); }
})();
})();
